// src/api/bookEditionsApi.js
import axios from "axios";

const BASE = `${process.env.REACT_APP_SERVER_URL}/api/bookEditions`;

/** Fetch the edition-check dashboard (requires admin auth). */
export async function fetchBookEditionStatus(token) {
    const { data } = await axios.get(`${BASE}/status`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return data;
}

/** Trigger a manual edition check (requires admin auth). */
export async function triggerEditionRefresh(token) {
    const { data } = await axios.post(
        `${BASE}/refresh`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
}

/** Permanently ignore this suggested ISBN/ASIN (requires admin auth). */
export async function dismissEditionSuggestion(bookId, asin, token) {
    const { data } = await axios.patch(
        `${BASE}/${bookId}/dismiss`,
        { asin },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
}

/** Acknowledge this edition and pause checks for its ISBN/ASIN for 24 hours. */
export async function acknowledgeEditionSuggestion(bookId, asin, token) {
    const { data } = await axios.patch(
        `${BASE}/${bookId}/acknowledge`,
        { asin },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
}
